import './scss/app.scss';
import QuizPanel from "./js/QuizPanel";
import {useEffect, useState} from "react";
import QuizHearIt from "./js/QuizHearIt";
import QuizMatchIt from "./js/QuizMatchIt";
import QuizIntro from "./js/QuizIntro";
import QuizSelector from "./js/QuizSelector";
import quizLogo from "./assets/images/quiz-icon.svg";
import arrow from "./assets/images/arrow.svg";
import QuizLearn from "./js/QuizLearn";

const phrases = [
    {
        id: 1,
        name: "hong-bao",
        text: {
            en: "Red Envelope",
            ch: "hóng bāo (紅包)"
        },
        sound: "https://s3.amazonaws.com/PandaExpressWebsite/lny/audio/red-envelope.mp3",
        video: {
            pronunciation: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/red-envelope-sound.mp4",
            writing: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/red-envelope-writing.mp4"
        }
    },
    {
        id: 2,
        name: "gong-xi-fa-cai",
        text: {
            en: "Wishing You Prosperity and Wealth",
            ch: "Gōng Xǐ Fā Cái (恭喜發財)"
        },
        sound: "https://s3.amazonaws.com/PandaExpressWebsite/lny/audio/wishing-you-prosperity-and-wealth-reg.m4a",
        video: {
            pronunciation: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/wishing-you-prosperity-and-wealth-audio.mp4",
            writing: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/wishing-you-prosperity-and-wealth-writing.mp4"
        }
    },
    {
        id: 3,
        name: "ni-hao",
        text: {
            en: "Hello",
            ch: "nǐ hǎo (你好)"
        },
        sound: "https://s3.amazonaws.com/PandaExpressWebsite/lny/audio/hello-reg.m4a",
        video: {
            pronunciation: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/hello-sound.mp4",
            writing: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/hello-writing.mp4"
        }
    },
    {
        id: 4,
        name: "xie-xie",
        text: {
            en: "Thank You",
            ch: "xiè xiè (谢谢)"
        },
        sound: "https://s3.amazonaws.com/PandaExpressWebsite/lny/audio/thank-you.mp3",
        video: {
            pronunciation: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/thank-you-sound.mp4",
            writing: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/thank-you-writing.mp4"
        }
    },
    {
        id: 5,
        name: "xin-nian-kuai-le",
        text: {
            en: "Happy New Year!",
            ch: "Xīn nián kuài lè (新年快乐)"
        },
        sound: "https://s3.amazonaws.com/PandaExpressWebsite/lny/audio/happy-new-year.mp3",
        video: {
            pronunciation: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/happy-new-year-sound.mp4",
            writing: "https://s3.amazonaws.com/PandaExpressWebsite/lny/video/chinese/happy-new-year-writing.mp4"
        }
    }
]
const initial = {
    panel: null,
    phrase: null,
    hearIt: phrases.map(p => ({...p, answers: [...phrases].sort((a, b) => 0.5 - Math.random())})),
    matchIt: [
        {
            id: 1,
            holders: [...phrases].sort((a, b) => 0.5 - Math.random()).slice(0, 3),
            answers: [...phrases].sort((a, b) => 0.5 - Math.random())
        },
        {
            id: 2,
            holders: [...phrases].sort((a, b) => 0.5 - Math.random()).slice(3, 5),
            answers: [...phrases].sort((a, b) => 0.5 - Math.random())
        }
    ]
}

function App() {
    const [quiz, setQuiz] = useState(initial)
    const [open, setOpen] = useState(false)
    const [show, setShow] = useState(false)

    const handle = {
        change: {
            panel: (panel, phrase) => {
                setShow(false)
                setTimeout(() => {
                    setQuiz({...quiz, panel, phrase})
                    setShow(true)
                }, 500)
            }
        }
    }

    useEffect(() => {
        setTimeout(() => setOpen(true), 200)
        setTimeout(() => setShow(true), 500)
    }, [])

    return (
        <div className="board">
            <div className="quiz-names">
                <ul>{phrases.map(p =>
                    <li key={p.id} className={`${p === quiz.phrase ? "active" : ""}`}>
                        <button onClick={() => handle.change.panel("learn", p)}>{p.text.en}</button>
                    </li>)}
                </ul>
                <button onClick={() => handle.change.panel("selector")}>
                    <img src={quizLogo} alt={"Panda quiz logo"} />
                    <span>Take a quiz <img src={arrow} alt={"arrow"} /></span>
                </button>
            </div>
            {
                quiz.panel === null ? <QuizPanel open={open} show={show} setShow={setShow} quiz={() => <QuizIntro/>}/>
                    : quiz.panel === "learn" ? <QuizPanel open={open} show={show} setShow={setShow} quiz={() => <QuizLearn question={quiz.phrase} />}/>
                    : quiz.panel === "selector" ?
                        <QuizPanel
                            open={open} show={show} setShow={setShow}
                            setPanel={handle.change.panel}
                            quiz={(p) => <QuizSelector setPanel={p} />}/>
                        : quiz.panel === "hear-it" ?
                            <QuizPanel open={open} questions={quiz.hearIt} show={show} setShow={setShow}
                                       setPanel={handle.change.panel}
                                       quiz={(q, next) => <QuizHearIt question={q} next={next} />}/>
                            : <QuizPanel open={open} questions={quiz.matchIt} show={show} setShow={setShow}
                                         setPanel={handle.change.panel}
                                         quiz={(q) => <QuizMatchIt question={q} />}/>
            }
        </div>
    )
}

export default App
